import React from "react";
import "./testimonials.css";

function Testimonials(props) {
  return <div></div>;
}

export default Testimonials;
